// Module
var code = "<template> <require from=\"app/cm/components/household/correspondence-history-grid\"></require> <correspondence-history-grid household-case-id.bind=\"householdCaseId\" config.bind=\"correspondenceConfig\"></correspondence-history-grid> </template> ";
// Exports
module.exports = code;